import { APP_MENU } from '../../constants/actions';
import { LOCATION_CHANGE } from 'react-router-redux';
const initialState = {
    open: false,
    selectOpen: false
};

function reducer(state = initialState, action) {
    switch (action.type) {
        case APP_MENU.SUB_OPEN:
            return { ...state, selectOpen: true };
        case APP_MENU.SUB_CLOSE:
            return { ...state, selectOpen: false };
        case APP_MENU.OPEN:
            return { ...state, open: true };
        case LOCATION_CHANGE:
        case APP_MENU.CLOSE:
            return { ...state, open: false, selectOpen: false };
        default:
            return state;
    }
}

export default reducer;
